import Backbone from "backbone";


let IconModel = Backbone.Model.extend("IconModel", {
    defaults: {
        plugin: "default",
        title: "default",
        mask: "default",
        x: 0,
        y: 0
    }
});

export default IconModel;
